import { render, staticRenderFns } from "./orderedList.vue?vue&type=template&id=6ab11e33&scoped=true&"
import script from "./orderedList.vue?vue&type=script&lang=js&"
export * from "./orderedList.vue?vue&type=script&lang=js&"
import style0 from "./orderedList.vue?vue&type=style&index=0&id=6ab11e33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab11e33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
